export default __webpack_public_path__ + "static/quickbook-hero-img-1ed0f2b4ab3e440b7ae07df619b2c5ee.png";